import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function cpfIsValid(value: string | null | undefined): boolean {
  if (!value || typeof value !== 'string') {
    return false;
  }

  const cleaned = value.replace(/\D/g, '');

  if (cleaned.length !== 11) {
    return false;
  }

  if (/^(\d)\1+$/.test(cleaned)) {
    return false;
  }

  const weights1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum1 = 0;
  for (let i = 0; i < 9; i++) {
    sum1 += Number(cleaned[i]) * weights1[i];
  }
  const remainder1 = sum1 % 11;
  const digit1 = remainder1 < 2 ? 0 : 11 - remainder1;

  if (digit1 !== Number(cleaned[9])) {
    return false;
  }

  const weights2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum2 = 0;
  for (let i = 0; i < 10; i++) {
    sum2 += Number(cleaned[i]) * weights2[i];
  }
  const remainder2 = sum2 % 11;
  const digit2 = remainder2 < 2 ? 0 : 11 - remainder2;

  return digit2 === Number(cleaned[10]);
}

export const cpfValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (value === null || value === undefined || value === '') {
    return null;
  }
  return cpfIsValid(value) ? null : { cpf: true };
};
